type ValueOf<T> = T extends Record<PropertyKey, infer V> ? ValueOf<V> : T

export const appBrands = {
  default: 'aladin',
  Aladin: 'aladin',
  Farmi: 'farmi',
  Episens: 'episens',
  Countrymalt: 'countrymalt',
} as const

export type AppBrand = ValueOf<typeof appBrands>
